<template>
	<div>
		<span
			class="tooltip-container"
			@focus="displayTooltip"
			@mouseover="displayTooltip"
			@mouseleave="hideTooltip"
			ref="tooltipTextRef"
		>
			<div>
				<slot name="container" />
			</div>
		</span>
		<Tooltip
			:text="tooltip"
			:display="tooltipVisible"
			:trackedRefName="'tooltipTextRef'"
			:position="position !== 'top-start' ? position : 'top-start'"
			:offset="[0, 4]"
		/>
	</div>
</template>

<script>
import Tooltip from '@/components/shells/tooltip/tooltip.vue';

export default {
	name: 'TooltipContainer',
	components: {
		Tooltip
	},
	data() {
		return {
			tooltipVisible: false
		};
	},
	props: {
		iconClassName: {
			type: String,
			default: 'icon-info'
		},
		tooltip: {
			type: String
		},
		placement: {
			type: String,
			default: 'auto'
		},
		/**
		 * Sets the variant of the element.
		 * Represents the global variation of the css
		 * @type {String}
		 */
		position: {
			type: String,
			default: 'top-start',
			validator: function validator(value) {
				return (
					[
						'auto',
						'auto-start',
						'auto-end',
						'top',
						'top-start',
						'top-end',
						'bottom',
						'bottom-start',
						'bottom-end',
						'right',
						'right-start',
						'right-end',
						'left',
						'left-start',
						'left-end'
					].indexOf(value) > -1
				);
			}
		}
	},

	methods: {
		displayTooltip() {
			if (this.tooltip) {
				this.tooltipVisible = true;
			}
		},
		hideTooltip() {
			this.tooltipVisible = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.tooltip-container {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	position: relative;
}
</style>
